<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <!-- <th v-for="(lista,index) in ListaHeader" :key="index"></th> -->
                <th :class="StyleTh + ' text-center'">#</th>
                <th :class="StyleTh">Tipo Documento</th>
                <th :class="StyleTh">Folio Salida</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">RFC</th>
                <th :class="StyleTh">Facturado</th>
                <!-- <th :class="StyleTh">Fecha Salida</th>
                <th :class="StyleTh">Fecha Llegada</th> -->
                <th :class="StyleTh">Fecha Alta</th>
                <th :class="StyleTh">Acciones</th>
            </template>
            
            <template slot="body">
                <tr v-for="(lista, index) in ListaArrayRows" :key="index" :class="{
                    'bg-salmon': lista.RegEstatus == 'B',
                    'bg-indianred': lista.EstatusCancel == 'Cancelado',
                }">
                    <td class="text-center"><p :class="StyleTd">{{ (index + 1) }} </p></td>
                    <td><p :class="StyleTd">{{ lista.TipoDocumento === 'T' ? 'Traslado' : 'Ingreso' }} </p></td>
                    <td><p :class="StyleTd">{{ lista.Serie+'-'+lista.Folio }} </p></td>
                    <td><p :class="StyleTd">{{ lista.NombreCliente }} </p></td>
                    <td><p :class="StyleTd">{{ lista.RfcCliente }} </p></td>
                    <td><p :class="StyleTd">{{ lista.Facturado }} </p></td>
                    <!-- <td><p :class="StyleTd">{{ lista.FechaSalida }} </p></td>
                    <td><p :class="StyleTd">{{ lista.FechaLlegada }} </p></td> -->
                    <td><p :class="StyleTd">{{ lista.FechaRegistro }} </p></td>
                    <td>
                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false"
                            :pObj="{ IdCotizacion: lista.IdCotizacion, IdCartaPorte: lista.IdCartaPorte }" :pId="lista.IdFactura"
                            :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <!-- <li @click="GenerarFactura(lista.IdFactura)">
                                            <a class="dropdown-item">
                                                <i class="far fa-list"></i> Ver Facturas
                                            </a>
                                        </li> -->
                                        <li @click="VerPdf(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Pdf
                                            </a>
                                        </li>
                                        <li @click="DescargarXML(lista.IdFactura)">
                                            <a class="dropdown-item">
                                                <i class="far fa-list"></i> Descargar XML
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="11"></CSinRegistros>

            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave2">
            <template slot="Form">
                <CancelFactForm :poBtnSave="oBtnSave2"></CancelFactForm>
            </template>
        </CModal>
    </div>
</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
import CancelFactForm from '@/views/modulos/finanzas/cartaporte/CancelFactForm'

const EmitEjecuta = 'seccionCartaporte';

export default {
    name: 'ListaCartaporte',
    props: ['pId'],
    components: {
        CancelFactForm
    },
    data() {
        return {
            ConfigList: {
                Title: 'Carta Porte',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                GoRoute: 'cartaporteform',
                Obj: {
                    IdCotizacion: 0,
                    IdCartaPorte: 0,
                },
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal: {
                ModalTitle: "Cancelar Factura",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'lg',
            },
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                TxtBtnSave: 'Cancelar factura',
                TxtBtnCancel: 'Cerrar',
                ReturnRoute: 'ListaCartaporte',
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista() {
            await this.$http.get("cp_CartaPorteFacturas", {
                params: {
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(() => {
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    this.$http.delete('cp_CartaPorteFacturas/' + Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                }
            });
        },
        AbrirModalCancelaFactura(idFactura) {
            this.bus.$emit('NewModal_' + this.ConfigList.EmitSeccion, idFactura);
        },
        CancelarFactura(ObjCancelacion) {
            // Cancela la factura
            let warn = { ...Configs.configEliminar }
            warn.title = '¿Desea cancelar la factura?';
            this.$swal(warn).then((result) => {
                if (result.value) {
                    this.$http.post('cartaPorte/postcancel.api', {
                        params: { Id: idFactura }
                    }).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista()
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    })
                }
            });
        },
        GenerarFactura(idFactura){
            // Generación del archivo de factura
        },
        DescargarXML(tipo, idFactura) {
            // Generar XML
            // var url =base_api+ "Cdowloadxml/Dowloadxml?Tipo=" + Tipo+'&Id='+Id;
            // window.open(url, "Dowload")
        },
        VerPdf(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdFactura: item.IdFactura
			}

			this.$http.post('rptpdfCP',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Factura",'CartaPorte_'+item.idFactura,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Regresar() {
            this.$router.push({ name: 'panelSubMenus', params: {} });
        },
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        this.bus.$off('Delete_' + EmitEjecuta);
        this.bus.$off('List_' + EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('Delete_' + EmitEjecuta, (Id) => {
            this.Eliminar(Id);
        });

        this.bus.$on('List_' + EmitEjecuta, () => {
            this.Lista();
        });
        this.bus.$on('EmitReturn', () => {
            this.Regresar();
        });
    }
}
</script>
<style scoped>.bg-salmon {
    background-color: rgb(248, 174, 166) !important;
}

.bg-indianred {
    background-color: rgb(248, 174, 166) !important;
}</style>